<template>
    <div>
        <menubar :permission="permission" />
        <div class="container">
            <div id="title" class="d-flex justify-content-start">
                <img src="/img/05_slash.svg" />
                <p class="h1">動画翻訳一覧</p>
            </div>
            <div class="translated-files-head"
                :class="$page.props.permission != 'オーナー' && $page.props.permission != 'マネージャー' ? 'translated-files-head__NonArchive' : ''">
                <Link v-show="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'"
                    :href="route('video_translate.archived_index')" class="btn btn-archive-file">
                アーカイブ済み動画
                </Link>
                <Link :href="route('video_translate.create')" class="btn btn-purple">
                字幕作成
                </Link>
            </div>
            <table class="component_table bilingual-file-table" cellpadding="5">
                <thead>
                    <tr>
                        <th class="th--file-name">ファイル</th>
                        <th class="th--status">状態</th>
                        <th class="th--team-name">チーム</th>
                        <th class="th--user-name">作成者</th>
                        <th class="th--user-name">編集中の<br />ユーザ</th>
                        <th class="th--language-pair">言語ペア</th>
                        <th class="th--aimodel-name">AIモデル</th>
                        <th class="th--glossary-name">用語集</th>
                        <th class="th--date">更新日</th>
                        <th class="th--dl-icon">DL</th>
                        <th class="th--checkbox"
                            v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
                            選択</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="videoTranslate in videoTranslates" v-bind:class="[
                        videoTranslate.status == 'PE' ? 'tr--pe' : 'tr--ai',
                        { 'tr--readonly': videoTranslate.is_editing != 0 }
                    ]">
                        <td class="td--file-name">
                            <div v-show="!videoTranslate.showNameInput" v-if="videoTranslate.status == 'PE'">
                                <a :href="route('video_translate.show', { id: videoTranslate.id, })" target="_blank">
                                    {{ videoTranslate.video_name }}
                                </a>
                            </div>
                            <div v-show="!videoTranslate.showNameInput" v-else>
                                {{ videoTranslate.video_name }}
                            </div>
                            <input class="form-control" style="max-width: 100%; display: inline-block"
                                v-show="videoTranslate.showNameInput" type="text" :value="videoTranslate.video_name" />
                            <div class="mt-3" style="text-align: right;">
                                <button v-show="videoTranslate.showNameInput" class="btn btn-red"
                                    style="font-size: 0.9rem; margin-left: 0.5rem"
                                    @click="changeFileName($event, videoTranslate.id)">
                                    更新
                                </button>
                                <button class="btn btn-purple" style="font-size: 0.9rem; margin-left: 0.5rem"
                                    @click="changeFileInputElement($event, videoTranslate.id)">
                                    <span v-show="!videoTranslate.showNameInput">変更</span>
                                    <span v-show="videoTranslate.showNameInput">戻す</span>
                                </button>
                            </div>
                        </td>
                        <!-- [TODO] ハードコーディング気味なので解消する -->
                        <td>
                            <div v-if="videoTranslate.status == 'PE' && videoTranslate.is_editing == 0"> 編集可 </div>
                            <div v-else-if="videoTranslate.status == 'PE' && videoTranslate.is_editing == 1"> 編集中 </div>
                            <div v-else-if="videoTranslate.status == 'AI'"> 翻訳中 </div>
                            <div v-else-if="videoTranslate.status == 'FL'"> 翻訳失敗 </div>
                        </td>
                        <td>{{ videoTranslate.team?.name ?? '削除済みチーム' }}</td>
                        <td>
                            <span v-if="videoTranslate.user">{{ videoTranslate.user.name }}</span>
                            <span v-else>(削除済み)</span>
                        </td>
                        <td>
                            <div v-if="videoTranslate.is_editing != 0 && videoTranslate.editing_user">
                                {{ videoTranslate.editing_user.name }}</div>
                            <div v-else></div>
                        </td>


                        <td>
                            {{ videoTranslate.src_language_code ?? 'なし' }} → {{ videoTranslate.trg_language_code ?? 'なし' }}
                        </td>
                        <td class="td--aimodel-name">
                            {{ videoTranslate.aimodel ? videoTranslate.aimodel.name : 'なし' }}
                        </td>
                        <td class="td--glossary-name">
                            <div v-if="videoTranslate.glossary !== null">
                                {{ videoTranslate.glossary.name }}
                                <div v-if="videoTranslate.glossary.deleted_at != null">(削除済み)</div>
                            </div>
                            <div v-else> 選択なし </div>
                        </td>

                        <td>{{ showLocalDate(videoTranslate.updated_at, "-") }}</td>
                        <td class="td--dl-icon">
                            <img v-if="videoTranslate.status == 'PE'" @click="openDownloadModal(videoTranslate.id, videoTranslate.subtitle_embed_status, videoTranslate.subtitle_embedded_at)"
                                src="/img/12_download.svg" class="btn--download" />
                        </td>

                        <td class="td--checkbox"
                            v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
                            <input v-if="videoTranslate.is_editing == 0 || videoTranslate.status == 'AI'" type="checkbox"
                                :id="videoTranslate.id" :value="videoTranslate.id" v-model="selectedFiles" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <DownloadModal ref="downloadModal" :downloadTypes="downloadTypes" :downloadVideoId="downloadVideoId" />

            <div class="translated-files-foot"
                v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー' || $page.props.permission == 'メンバー'">
                <button class="btn btn-purple" v-if="$page.props.permission == 'オーナー' || $page.props.permission == 'マネージャー'"
                    @click="archiveVideos">アーカイブ</button>
                <button class="btn btn-red" @click="deleteFiles">削除</button>
            </div>
        </div>
        <footerComponent />
    </div>
</template>
  
<script>
import menubar from "@/Pages/Common/menu";
import { Link } from "@inertiajs/inertia-vue3";
import footerComponent from "@/Pages/Components/footer.vue";
import showLocalDate from "@/Pages/Components/showLocalDate.js";
import modal from '@/Pages/Components/modal.vue';
import axios from "axios";
import DownloadModal from "../../Components/DownloadModal.vue";

export default {
    components: {
        menubar,
        footerComponent,
        Link,
        modal,
        DownloadModal,
    },
    props: {
        rootAimodels: Object,
        aimodels: Object,
        teams: Object,
        permission: String,
    },
    props: {
        videoTranslates: Object,
        downloadTypes: Array,
    },

    data() {
        return {
            selectedFiles: [],
            login_authority: false,
            archiveFileName: [],
            deleteFileName: [],

            downloadVideoId: 0, // undefinedだとziggyのrouteでエラーになるの1を設定
            downloadType: 1,
        };
    },
    computed: {},
    methods: {
        showLocalDate: function (date, separator) {
            return showLocalDate.showLocalDate(date, separator);
        },
        changeFileName: function ($event, id) {
            const newVideoName = $event.srcElement.parentNode.parentNode.getElementsByTagName('input')[0].value;
            if (newVideoName === '') {
                alert('対訳ファイル名を空白にすることはできません。');
                return;
            }

            const formData = new FormData();
            formData.append('videoName', newVideoName);
            axios.post(this.route('video_translate.update', id), formData)
                .then((res) => {
                    const file = this.getFileById(id);
                    file.showNameInput = false;
                    alert('ファイル名を変更しました。');
                    location.reload();

                }).catch((err) => {
                    const data = err?.response?.data;
                    if (data?.error === undefined) {
                        console.log(err);
                        alert('予期せぬエラーが発生しました。もう一度お試しください。');
                        return;
                    }
                    const message = Object.values(data.error)[0];
                    alert(message);
                });
        },
        changeFileInputElement($event, id) {
            let file = this.getFileById(id);
            file.showNameInput = !file.showNameInput;

        },
        getFileById(id) {
            return this.videoTranslates.filter((a) => { return a.id == id; })[0];
        },
        visitPostEdit(id) {
            this.$inertia.visit(route('post-edit.index', { id: id, }));
        },
        setLoginAuthority() {
            this.login_authority = !this.login_authority;
        },
        openFile(fileName) {
            confirm(fileName + "を開きますか？");
        },
        archiveVideos() {
            if (this.selectedFiles.length == 0) {
                alert("選択列の一つ以上のチェックボックスにチェックしてください");
                return;
            }
            if (!confirm("選択したファイルをアーカイブします。よろしいですか？")) {
                return;
            }

            //アーカイブするエンドポイントは1つのファイルのidしか受け取らないので、失敗したとこは記録してフロントに表示する
            const failedResult = [];
            Promise.all(this.selectedFiles.map(async (id) => {
                await axios.patch(route("video_translate.archive", id)
                ).catch((e) => {
                    const data = e.response.data;
                    const message = Object.values(data.error)[0];
                    failedResult.push({ 'id': id, 'message': message });
                });
            })).finally(() => {
                if (failedResult.length === 0) {
                    alert('動画をアーカイブ化しました。');
                } else {
                    const errorMessage = failedResult.reduce((carry, d) => {
                        return carry + d.message + "\n"
                    }, '');
                    console.dir(errorMessage);
                    alert(errorMessage);
                }
                location.reload();
            });
        },
        deleteFiles() {
            if (this.selectedFiles.length == 0) {
                alert("選択列の一つ以上のチェックボックスにチェックしてください");
                return;
            }
            if (!confirm("この操作はやり直せません")) {
                return;
            }
            //ファイル削除するエンドポイントは1つのファイルのidしか受け取らないので、失敗したとこは記録してフロントに表示する
            const failedResult = [];
            Promise.all(this.selectedFiles.map(async (id) => {
                await axios.delete(route("video_translate.delete", id)
                ).catch((e) => {
                    const data = e.response.data;
                    const message = Object.values(data.error)[0];
                    failedResult.push({ 'id': id, 'message': message });
                });
            })).finally(() => {
                if (failedResult.length === 0) {
                    alert('動画を削除しました。');
                } else {
                    const errorMessage = failedResult.reduce((carry, d) => {
                        return carry + d.message + "\n"
                    }, '');
                    console.dir(errorMessage);
                    alert(errorMessage);
                }
                location.reload();
            });
        },
        openDownloadModal(id, subtitleEmbedStatus, subtitleEmbeddedAt) {
            this.$refs.downloadModal.openDownloadModal(id, subtitleEmbedStatus, subtitleEmbeddedAt);
        },
    },
    beforeMount() {
        this.videoTranslates.forEach((f) => {
            f.showNameInput = false;
        });
    }
};
</script>
  
<style lang="scss" scoped>
.container {
    min-height: 80vh;
}

//=[ページの見出し]==========================================================//
#title {
    margin: 3rem 0;

    img {
        width: 3rem;
        height: 3rem;
    }

    p {
        color: #333333;
    }
}

//==========================================================================//

//=[テーブル上部の要素]======================================================//
.translated-files-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;

    .btn-archive-file {
        color: #763fd0;
        border-color: #763fd0;
        border-radius: 100vh;
    }
}

.translated-files-head__NonArchive {
    justify-content: flex-end;
}

//==========================================================================//

//=[テーブル本体]============================================================//
.bilingual-file-table {
    width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    text-align: center;

    thead {
        border-top: 2px;
        height: 3rem;
    }

    tbody {
        border-top: 0;

        tr.tr--ai>td {
            background: #e4d8f5;
        }

        td {
            padding: 10px;
        }
    }
}

// Table ヘッダの幅に関するスタイル
.th--file-name {
    width: 20%
}

.th--aimodel-name,
.th--glossary-name {
    width: auto;
}

.th--team-name,
.th--user-name,
.th--date {
    width: 8rem;
}

.th--language-pair {
    width: 6rem;
}

.th--status {
    width: 5rem;
}

.th--dl-icon,
.th--checkbox {
    width: 4rem;
}

.tr--readonly>td {
    background: #e7e7eb;
}

// Table セルに関するスタイル
.td--file-name,
.td--aimodel-name,
.td--glossary-name {
    text-align: left;
    padding: 0 0 0 1rem;
}

.td--dl-icon,
.td--checkbox {
    text-align: center;
    vertical-align: middle;
}

.btn--download {
    width: 20px;
}

//==========================================================================//

//=[テーブル下部の要素]======================================================//
.translated-files-foot {
    text-align: end;
    margin: 1rem 0;

    button {
        margin: 0 0 0 1rem;
    }

    .switchAuthority {
        text-align: start;
    }

    .buttonArchiveDelete {
        text-align: end;
    }
}

.lang-pair-select {
    -webkit-appearance: none;
    appearance: none;
    /* デフォルトの矢印を無効 */
    color: #999;
    font-size: 1rem;
    padding: 0.4rem 2.4rem 0.4rem 0.4rem;

    background-image: url(/img/16_tri.svg);
    background-repeat: no-repeat;
    background-size: 1.3rem;
    background-position: right 0.2rem center;

    border: 1px solid #ced4da;
    border-radius: 0.2rem;
}

.lang-pair-select::-ms-expand {
    display: none;
    /* デフォルトの矢印を無効(IE用) */
}

//==========================================================================//
</style>